import React from "react";
import styled from "styled-components";

const Avatar = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
`;

const ImagePlacer = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #040303;
  border: solid 1px #463434;
`;

const ImagePlacer2 = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #040303;
  border: solid 1px #463434;
`;

const Initials = styled.h1`
  font-family: Playfair Display;
  color: #fffcf2;
`;

const Initials2 = styled.h1`
  font-family: Playfair Display;
  color: #fffcf2;
  font-size: 18px;
`;

export { Avatar, ImagePlacer, Initials, ImagePlacer2, Initials2 };
